import { render } from "./PortfolioSingle.vue?vue&type=template&id=3ca058fe"
import script from "./PortfolioSingle.vue?vue&type=script&lang=js"
export * from "./PortfolioSingle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__